/**
 * One warning per node property whose reference resolves to a class the slot's
 * `PROPERTY_HINT_RESOURCE_TYPE` hint excludes with a `-` prefix. The setter keeps the value, and the
 * editor never offers the class (`editor_resource_picker.cpp:827-833`), so the value is outside the
 * property's UI hint: a warning (ADR-0032).
 */
import { FILE_DIAGNOSTICS } from './fileDiagnostics.js';
import { armDiagnostic } from './ruleArms.js';
import { resolveResourceSlot } from './resourceChecker.js';
import { propertyLocation } from './sourceLocation.js';
import { excludingHint } from '../godot/classdb/excludingHint.js';
function sweep(scene, owner, lines, into) {
    for (const [key, value] of Object.entries(owner.rawProperties)) {
        const hint = excludingHint(owner.type, key);
        if (!hint)
            continue;
        const slot = resolveResourceSlot(scene, value);
        if (slot.kind !== 'resolved' || !hint.excluded.includes(slot.type))
            continue;
        into.push(armDiagnostic(FILE_DIAGNOSTICS.resourceTypeExcludedByHint, owner, `Property '${key}' holds the type ${slot.type}, which the hint of ${hint.declaredBy}.${key} ` +
            `("${hint.hintString}") excludes. The editor never offers this type for the slot.`, propertyLocation(lines, owner, key)));
    }
}
/** Each excluded resource type, on the line of the node property that holds it. */
export function excludedResourceTypeDiagnostics(scene, lines) {
    const diagnostics = [];
    const visit = (node) => {
        sweep(scene, node, lines, diagnostics);
        for (const child of node.children)
            visit(child);
    };
    for (const node of scene.nodes)
        visit(node);
    return diagnostics;
}
//# sourceMappingURL=excludedResourceTypes.js.map